import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchTyres = (params = {}) => api.get("/tyres", { params }).then((r) => r.data);
export const fetchTyreCount = (params = {}) => api.get("/tyres/count", { params }).then((r) => r.data);
export const fetchTyre = (id) => api.get(`/tyres/${id}`).then((r) => r.data);
export const fetchRelated = (id) => api.get(`/tyres/${id}/related`).then((r) => r.data);
export const fetchSizes = () => api.get("/tyres/sizes").then((r) => r.data);
export const fetchServices = () => api.get("/services").then((r) => r.data);
export const fetchTestimonials = () => api.get("/testimonials").then((r) => r.data);
export const fetchBrands = () => api.get("/brands").then((r) => r.data);
export const fetchEmergencyTools = (params = {}) => api.get("/emergency-tools", { params }).then((r) => r.data);
export const createOrder = (payload) => api.post("/orders", payload).then((r) => r.data);
export const fetchOrder = (id) => api.get(`/orders/${id}`).then((r) => r.data);
export const fetchSearchSuggest = (q, limit = 8) =>
  api.get("/search/suggest", { params: { q, limit } }).then((r) => r.data);
export const fetchSearchPopular = (limit = 4) =>
  api.get("/search/popular", { params: { limit } }).then((r) => r.data);
